/* unplugin-vue-components disabled */import script from "./swiper.vue?vue&type=script&setup=true&lang=js"
export * from "./swiper.vue?vue&type=script&setup=true&lang=js"

import "./swiper.vue?vue&type=style&index=0&id=31c621a5&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31c621a5"]])

export default __exports__